module.exports = __webpack_public_path__ + "img/thumbnail_AlpineIbex_j_normal.c7058273.png";